
















import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component<FilterBarSecondary>({
    components: {}
})
export default class FilterBarSecondary extends Vue {

    @Getter public tsMobileView

    // get URL parameter: ?returning=promoter-detractor|detractor-promoter
    readonly urlParam = new URLSearchParams(window.location.search).get('returning') ?? ''

    public formatLabel() {
        // WEB-8118 only two options at the moment
        return (this.urlParam === 'promoter-detractor')
            ? 'Promoters turned Detractors' : 'Detractors turned Promoters'
    }

    public removeParamFilter() {
        // remove URL parameter will remove the filter displaying
        window.location.href = '/responses'
    }

}
